import React from 'react';
import { connect } from 'react-redux';
import { BaseStore } from 'src/store';
import { ProductEntity } from 'src/modules/products';
import { ProductsDownloads } from 'src/modules/products';
import styles from './ProductsDetailsOverlaySectionDownload.module.scss';

interface ProductsDetailsOverlaySectionDownloadProps {
  product: ProductEntity;
}

const ProductsDetailsOverlaySectionDownload: React.FunctionComponent<ProductsDetailsOverlaySectionDownloadProps> = (
  props: ProductsDetailsOverlaySectionDownloadProps
) => {
  return (
    <div className={styles.container}>
      <h3>Downloads</h3>
      <ProductsDownloads product={props.product} className={styles.downloads} />
    </div>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return { ...state.products.details };
};

export default connect(mapStateToProps)(ProductsDetailsOverlaySectionDownload);
